<template>
	<div>
		<!-- <el-dialog title="请选择一流课程类型" :append-to-body="true" :show-close="false" :close-on-click-modal="false"
			:visible.sync="typeDialogVisible" :center="true" width="30%">
			<el-select style="width: 100%;" v-model="formType" placeholder="请选择一流课程类型">
				<el-option label="线上课程" value="xskc">
				</el-option>
				<el-option label="线下课程" value="xxkc">
				</el-option>
				<el-option label="线上线下混合式课程" value="hhs">
				</el-option>
				<el-option label="虚拟仿真实验教学课程" value="xnfz">
				</el-option>
				<el-option label="社会实践课程" value="shsj">
				</el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="typeClose">取 消</el-button>
				<el-button type="primary" @click="typeConfig">确 定</el-button>
			</span>
		</el-dialog> -->
		<el-dialog class="review-submit" title="提示" :visible.sync="dialogVisible" top="5vh" width="90vw"
			:before-close="close" :close-on-click-modal="false">
			<div class="dialog-head flex-sb" slot="title">
				<div>{{dioTitle}}</div>
				<div><i class="el-icon-close"></i></div>
			</div>
			<div class="dialog-content" v-loading="loading">

				<div class="form" :key="formType">
					<el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top"
						class="demo-ruleForm">
						<el-form-item
							v-if="!item.target || (item.target && item.targetValue.includes(ruleForm[item.target]))"
							:style="{width:item.width}" v-for="(item,index) in formFielList" :key="index"
							:label="item.label" :prop="item.field">
							<!-- 标题 -->
							<div class="cell-title" :style="item.style" v-if="item.type === 'title'">
								<div class="til">{{item.title}}</div>
							</div>
							<!-- 提示 -->
							<div :style="item.style" v-else-if="item.type === 'tips'">
								<div class="tips">{{item.tips}}</div>
							</div>
							<!-- 下拉框 -->
							<el-select  :disabled="item.disabled" :multiple="!!item.multiple" collapse-tags v-else-if="item.type === 'select'"
								style="width: 100%;" :placeholder="item.placeholder || item.label"
								v-model="ruleForm[item.field || 'test']" @change="selectChange(item.field,$event)">
								<el-option :label="v[item.rangLabel]" :value="v[item.rangValue]"
									v-for="(v,i) in item.option"></el-option>
							</el-select>
							<!-- 单字表单多下拉框 -->
							<div class="select-composite flex-sb" v-else-if="item.type === 'select-composite'">
								<el-select v-for="(s,k) in item.composite"  :disabled="s.disabled" :style="{width:s.width}"
									:placeholder="s.placeholder || s.label" :multiple="!!s.multiple" collapse-tags
									v-model="ruleForm[s.field || 'test']">
									<el-option :label="v[s.rangLabel]" :value="v[s.rangValue]"
										v-for="(v,i) in s.option"></el-option>
								</el-select>
							</div>
							<div v-else-if="item.type === 'select-school'">
								<el-select style="width: 100%;" :disabled="item.disabled" v-model="ruleForm[item.field || 'test']" filterable
									remote reserve-keyword placeholder="输入查询所属院校" :remote-method="remoteMethod"
									:loading="universityLoading">
									<el-option v-for="schoolItem in universityOptions" :key="schoolItem.id"
										:label="schoolItem.name" :value="item.rangValue ? schoolItem[item.rangValue] : schoolItem.id">
									</el-option>
								</el-select>
							</div>
							<!-- 日期 -->
							<el-date-picker :disabled="item.disabled" v-else-if="item.type === 'date'" style="width: 100%;"
								v-model="ruleForm[item.field || 'test']" :type="item.dateType || 'date'"
								value-format="yyyy-MM-dd" :placeholder="item.placeholder || item.label">
							</el-date-picker>
							<!-- 单选框 -->
							<el-radio-group :disabled="item.disabled" v-model="ruleForm[item.field || 'test']" v-else-if="item.type === 'radio'">
								<el-radio v-for="(v,i) in item.option"
									:label="v[item.rangValue]">{{v[item.rangLabel]}}</el-radio>
							</el-radio-group>
							<!-- 文件上传 -->
							<upload :disabled="item.disabled" v-else-if="item.type === 'upload'" :limit="item.limit" :text="item.text"
								:localList="ruleForm[item.field]" :tips="item.tips || ''"
								:tipslink="item.tipslink || ''" :linkUrl="item.linkUrl || ''"
								:accept="item.accept || '.png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.xls,.xlsx'"
								@success="uploadSuccess($event,item.field)">
							</upload>
							<!-- textarea -->
							<el-input :disabled="item.disabled" :style="{width:item.conWidth}" :show-word-limit="true" resize="none"
								v-else-if="item.type === 'textarea'" type="textarea" :rows="item.rows || 3"
								:placeholder="item.placeholder || item.label" v-model="ruleForm[item.field || 'test']">
							</el-input>
							<!-- 独立标题附件上传 -->
							<div v-else-if="item.type === 'upload-independent'">
								<!-- 			<div style="margin: 0 -10px;">
									<el-divider>
										<i :class="[dividerIcon[ Math.floor(Math.random() * (dividerIcon.length))]]"></i>
									</el-divider>
								</div> -->
								<div style="margin-left: -20px;margin-bottom: 10px;" class="cell-title col-center">
									<div class="til" v-if="item.title">{{item.title}}</div>
									<div class="itips">
										{{item.tTips}}
									</div>
								</div>
								<div class="files">
									<upload :disabled="item.disabled" :limit="item.limit" :text="item.text" :localList="ruleForm[item.field]"
										:tips="item.tips || ''" :tipslink="item.tipslink || ''"
										:linkUrl="item.linkUrl || ''"
										:accept="item.accept || '.png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.xls,.xlsx'"
										@success="uploadSuccess($event,item.field)">
									</upload>
								</div>
								<div style="margin: 0 -10px;" v-if="item.divider">
									<el-divider>
										<i
											:class="[dividerIcon[ Math.floor(Math.random() * (dividerIcon.length))]]"></i>
									</el-divider>
								</div>
							</div>
							<!-- 复合附件上传 -->
							<div v-else-if="item.type === 'upload-composite'">
								<div style="margin-left: -20px;margin-bottom: 20px;" class="cell-title col-center">
									<div class="til">{{item.title}}</div>
								</div>
								<div style="margin-left: -10px;" v-for="(v,i) in item.composite" :key="i">
									<div style="padding-left: 10px;">
										<div class="sub-files-title">
											<div style="margin-left: -10px;">
												{{v.title}}
											</div>
											<div class="ftips">
												{{v.tTips}}
											</div>
										</div>
										<div class="files">
											<upload :disabled="v.disabled" :limit="v.limit" :text="v.text" :localList="ruleForm[v.field]"
												:tips="v.tips || ''"
												:accept="v.accept || '.png,.jpg,.jpeg,.webp,.pdf,.doc,.docx,.xls,.xlsx'"
												@success="uploadSuccess($event,v.field)">
											</upload>
										</div>
									</div>
									<div>
										<el-divider>
											<i
												:class="[dividerIcon[ Math.floor(Math.random() * (dividerIcon.length))]]"></i>
										</el-divider>
									</div>
								</div>
							</div>
							<div v-else-if="item.type === 'table'">
								<cusTable :disabled="item.disabled" :list="item.list || []" :addText="item.addText || ' 添加团队成员'" :max="item.max"
									@change="tableChange($event,item.field)" :tips="item.tips" :column="item.column">
								</cusTable>
							</div>
							<!-- 数字输入框 -->
							<el-input :disabled="item.disabled" v-else-if="!item.type && item.inputType === 'number'"
								:maxlength="item.maxlength || 300" type="number"
								v-model="ruleForm[item.field || 'test']"
								:placeholder="item.placeholder || item.label"></el-input>
							<!-- 普通输入框 -->
							<el-input :disabled="item.disabled" v-else :maxlength="item.maxlength || 300"
								:placeholder="item.placeholder || item.label"
								v-model="ruleForm[item.field || 'test']"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<!-- <div>
					以上文件大小每个不超过2M。每种教材单独设置文件夹，以“高校简称+教材名称”命名，内含以上第(1)-(7)项材料（材料无需合并）。
				</div> -->
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" plain @click="submitRes('cache')" :disabled="isCache">暂 存</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确认提交</el-button>
			</span>
		</el-dialog>
	</div>

</template>

<script>
	// 接口api
	import {
		submitReportDetail,
		submitReportDetailZ,
	} from '@/common/api/report.js'
	import {
		getCommonOption
	} from '@/common/api/public.js'
	// 文件上传获取上传路径
	import {
		baseUrl
	} from '@/common/config.js'
	let urlRes = ''
	urlRes = window.location.protocol + "//" + window.location.host + "/api/"
	if (urlRes.indexOf('localhost') !== -1) {
		urlRes = 'http://10.0.7.202:8484/api/'
	}
	if (baseUrl) {
		urlRes = baseUrl
	}
	import {
		validatePhone,
		validateEmail
	} from '../../utils/reg.js'
	import upload from "./upload"
	// 导入字段数据js
	import field from './field-child/field.js'
	import cusTable from './field-child/table'
	import {
		getUniversityList
	} from '@/common/api/public.js'
	export default {
		name: '',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			theme: {
				type: Array,
				default () {
					return []
				}
			}
		},
		components: {
			upload,
			cusTable
		},
		watch: {
			value: {
				handler(v) {
					this.dialogVisible = v
				},
				deep: true,
				imediate: true,
			},
			theme: {
				handler(v) {
					this.themeArray = v
				},
				deep: true,
				imediate: true,
			},

		},
		data() {
			// 手机号正则验证
			// let validatePhone = (rule, value, callback) => {
			// 	let reg = /^1[3-9]\d{9}$/
			// 	if (value === '') {
			// 		callback(new Error('请填写手机号'));
			// 	} else if (!reg.test(value)) {
			// 		callback(new Error('请填写正确的手机号'));
			// 	} else {
			// 		callback();
			// 	}
			// };
			// let validateEmail = (rule, value, callback) => {
			// 	let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
			// 	if (value && !reg.test(value)) {
			// 		callback(new Error('邮箱格式有误'));
			// 	} else {
			// 		callback()
			// 	}
			// };
			return {
				baseUrl: urlRes,
				dialogVisible: false,
				typeDialogVisible: false,
				loading: false,
				isCache: false,
				universityLoading: false,
				universityOptions: [],
				dividerIcon: ['el-icon-star-off', 'el-icon-help', 'el-icon-picture-outline-round', 'el-icon-umbrella',
					'el-icon-scissors', 'el-icon-coordinate', 'el-icon-mouse', 'el-icon-headset',
					'el-icon-magic-stick', 'el-icon-collection-tag', 'el-icon-price-tag', 'el-icon-chat-round',
					'el-icon-set-up', 'el-icon-message', 'el-icon-alarm-clock', 'el-icon-basketball',
					'el-icon-baseball', 'el-icon-light-rain', 'el-icon-lightning', 'el-icon-cloudy',
					'el-icon-partly-cloudy', 'el-icon-sunset', 'el-icon-cloudy-and-sunny', 'el-icon-apple',
					'el-icon-grape', 'el-icon-pear'
				],
				themeArray: [],
				formFielList: [],
				formType: '',
				ruleForm: {
					test: ''
				},
				rules: {

				},
				// 附件相关
				headers: {
					Authorization: ''
				},
				dioTitle: '提交参赛作品',
				typeIndex: {
					xskc: 1,
					xxkc: 2,
					hhs: 3,
					xnfz: 4,
					shsj: 5,
				}
			}
		},
		created() {
			let token = localStorage.getItem('access_token')
			this.headers.Authorization = "Bearer " + token
			console.log(field, "fieldfieldfieldfieldfieldfieldfield")
		},
		mounted() {

		},
		methods: {
			// 如果是编辑，获取详情
			async getDetail(id) {
				this.loading = true
				this.isCache = true
				const {
					data
				} = await submitReportDetail({
					id
				})
				console.log(data)
				this.setDetailInfo(data)
				this.initForm('editor', data)
			},
			setDetailInfo(data) {
				for (let key in data.team_principal) {
					data['team_principal-' + key] = data.team_principal[key]
				}
				delete data.team_principal
				field.form.forEach((item, index) => {
					if (item.type === 'select' && item.multiple && data[item.field]) {
						data[item.field] = data[item.field].split(',')
					}
					if (item.type === 'table' && data[item.field] && data[item.field].length) {
						item.list = data[item.field]
					}
					if (item.composite && item.composite.length) {
						item.composite.forEach((v, i) => {
							if (item.type === 'select-composite' && v.multiple && data[v.field]) {
								data[v.field] = data[v.field].split(',')
							}
						})
					}
				})
				this.ruleForm = data
				this.dialogVisible = true
				this.loading = false
				this.initForm('editor', data)
			},
			close() {
				this.ruleForm = {

				}
				this.dioTitle = "提交参赛作品"
				this.dialogVisible = false
				this.$emit('close')
			},
			open(data) {
				if (data) {
					this.setDetailInfo(data)
				} else {
					this.initForm()
					// this.formFielList = JSON.parse(JSON.stringify(field.form))
					this.dialogVisible = true
				}


			},
			// 提交申报
			submitRes(cache) {
				console.log(cache, '111111111')
				this.loading = true
				let obj = JSON.parse(JSON.stringify(this.ruleForm))
				let team_principal = {

				}
				for (let key in obj) {
					if (key.indexOf('team_principal') !== -1) {
						let kArr = key.split('-')
						team_principal[kArr[1]] = obj[key]
						delete obj[key]
					}
				}

				console.log(obj)
				if(obj.teacher && obj.teacher.length){
					obj.teacher = obj.teacher.map((m, i) => {
						m.sort = i
						return m
					})
				}
				if(obj.team && obj.team.length){
					obj.team = obj.team.map((m, i) => {
						m.sort = i
						return m
					})
				}
				obj.team_principal = team_principal
				this.$emit('submit', obj, (cache === 'cache' ? 'cacha' : ''))
			},
			submitForm(formName) {
				console.log(this.ruleForm)

				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.ruleForm.teacher || this.ruleForm.teacher.length < 1) {
							return this.$message.error("请填写第一指导教师")
						} else {
							let flag = true
							this.ruleForm.teacher.forEach((item, index) => {
								if (!flag) {
									return
								}
								if (!item.name) {
									flag = false
									this.$message.error("第" + (index + 1) + '行指导教师姓名为必填，请检查！')
								}
								if (!flag) {
									return
								}
								if (!item.phone) {
									flag = false
									this.$message.error("第" + (index + 1) + '行指导教师联系方式为必填，请检查！')
								}
							})
							if (!flag) {
								return
							}
						}

						if (!this.ruleForm.team || this.ruleForm.team.length < 2) {
							return this.$message.error("请至少添加两名团队成员")
						} else {
							let flag = true
							this.ruleForm.team.forEach((item, index) => {
								if (!flag) {
									return
								}
								if (!item.name) {
									flag = false
									this.$message.error("第" + (index + 1) + '行团队成员姓名为必填，请检查！')
								}
								if (!flag) {
									return
								}
								if (!item.phone) {
									flag = false
									this.$message.error("第" + (index + 1) + '行团队成员联系方式手机号为必填，请检查！')
								}
								if (!flag) {
									return
								}
								if (!item.education) {
									flag = false
									this.$message.error("第" + (index + 1) + '行团队成员学历为必填，请检查！')
								}
								if (!flag) {
									return
								}
								if (!item.school_name) {
									flag = false
									this.$message.error("第" + (index + 1) + '行团队成员学校为必填，请检查！')
								}
								if (!flag) {
									return
								}
								if (!item.academy) {
									flag = false
									this.$message.error("第" + (index + 1) + '行团队成员学院为必填，请检查！')
								}
								if (!flag) {
									return
								}
								if (!item.profession) {
									flag = false
									this.$message.error("第" + (index + 1) + '行团队成员专业为必填，请检查！')
								}
							})
							if (!flag) {
								return
							}
						}
						this.submitRes()
					} else {
						console.log('error submit!!');
						this.$message.error("您有未填项请检查")
						return false;
					}
				});

			},
			resetForm(formName) {
				this.$refs.ruleForm.clearValidate();
			},
			// 附件相关
			uploadSuccess(files, filed) {
				console.log(files)
				this.ruleForm[filed] = files
			},
			// 表格
			tableChange(v, filed) {
				console.log(v, filed)
				if (v && v.length) {
					this.ruleForm[filed] = v.filter((f) => {
						if (f && JSON.stringify(f) !== '{}') {
							return f
						}
					})
				}
			},
			// 下拉选择change事件
			selectChange(f, v) {
				console.log(f, v, this.ruleForm)
				if (f === 'type') {

					// this.ruleForm = {
					// 	type:v
					// }
					let obj = {}
					field[v].form.forEach((item, v) => {
						if (this.ruleForm[item.field] && this.ruleForm[item.field] && item.type !==
							'select-composite') {
							obj[item.field] = this.ruleForm[item.field]
						}
					})
					this.ruleForm = {
						type: v,
						...obj
					}
					this.formType = v

					this.initForm()
				}
				// this.$forceUpdate()
			},
			typeClose() {
				this.typeDialogVisible = false
				this.formType = ''
			},
			async initForm(editor, editorData) {
				this.loading = true
				try {
					const {
						data
					} = await getCommonOption()
					this.loading = false
					// console.log(data)
					field.form.forEach((item, index) => {
						if (item.filed) {
							if (item.dataType === 'array') {
								this.ruleForm[item.filed] = []
							} else {
								this.ruleForm[item.filed] = ''
							}
						}
						// 使用接口的option参数
						if (item.actionOption && data[item.actionOption] && data[item.actionOption].length) {
							item.option = data[item.actionOption]
							item.rangLabel = 'name'
							item.rangValue = 'id'
							data[item.actionOption].forEach((m, q) => {
								if (m.is_fill == 1) {
									field[this.formType].form.forEach((x, y) => {
										if (x.target && x.target == item.field) {
											x.targetValue.push(m.id)
										}
									})
								}
							})
						}
						if (item.composite && item.composite.length) {
							item.composite.forEach((v) => {
								if (v.dataType === 'array') {
									this.ruleForm[v.filed] = []
								} else {
									this.ruleForm[v.filed] = ''
								}
								if (v.actionOption && data[v.actionOption] && data[v.actionOption]
									.length) {
									v.option = data[v.actionOption]
									v.rangLabel = 'name'
									v.rangValue = 'id'
								}
							})
						}
						if (editor === 'editor' && item.type === 'table' && editorData[item.field] &&
							editorData[item.field].length) {
							item.list = editorData[item.field]
						} else if (editor === 'editor' && item.type === 'table' && item.field == 'issue') {
							if (editorData[item.field] && editorData[item.field].data.length) {
								item.list = editorData[item.field].data
							}
						}
						if (item.type === 'table') {
							if (editor !== 'editor') {
								item.list = []
							}
							item.column.forEach((v, i) => {
								if (v.actionOption && data[v.actionOption] && data[v.actionOption]
									.length) {
									v.option = data[v.actionOption]
									v.rangLabel = 'name'
									v.rangValue = 'id'
								}
							})
						}
					})
					// 渲染选择的表单类型
					let obj = JSON.parse(JSON.stringify(field))
					this.formFielList = obj.form
					// console.log(this.formFielList,'this.formFielListthis.formFielListthis.formFielList')
					this.rules = obj.rules || {}
					this.$nextTick(() => {
						this.resetForm()
					})
				} catch (e) {
					console.error(e)
					this.loading = false
				}

			},
			typeConfig() {
				if (!this.formType) {
					this.$message.error("请选择参赛作品类型")
				} else {
					// 设置form字段
					this.initForm()

					// 赋值表单类型
					this.$nextTick(() => {
						this.$set(this.ruleForm, 'type', this.formType)
						// this.resetForm()
					})
					this.dialogVisible = true;
					this.typeDialogVisible = false

				}
			},
			cacheData() {

			},
			// 查询高校
			async remoteMethod(query) {
				if (query !== '') {
					this.universityLoading = true;
					const {
						data
					} = await getUniversityList({
						key_words: query,
						per_page: 20
					})
					this.universityOptions = data.data
					this.universityLoading = false
					console.log(this.universityOptions, 1111111111)
				}
			},
		}

	}
</script>

<style lang="scss" scoped>
	::v-deep .el-dialog__header {
		background-color: #4389DF;
		padding: 1.125rem 1.25rem;
	}

	::v-deep .el-dialog {
		border-radius: 0.625rem;
		overflow: hidden;
	}

	::v-deep .el-form-item {
		margin-bottom: 0.625rem;
	}

	::v-deep .el-form-item {
		width: calc(100% / 3);
		margin: 0 0 1.25rem 0;
	}

	::v-deep .el-form .el-form-item {
		padding: 0 10px;
		box-sizing: border-box;
	}

	::v-deep .el-table__header tr,
	::v-deep .el-table__header th {
		background-color: #F8F8F8;
	}

	::v-deep .el-table td.el-table__cell,
	::v-deep .el-table th.el-table__cell.is-leaf {
		border-bottom: 0 none;
	}

	::v-deep .el-table--border::after,
	::v-deep .el-table--group::after,
	::v-deep .quill-editor {
		padding: 0;
	}

	::v-deep {
		.el-input__suffix-inner {
			color: #000 !important;
		}
	}

	.ql-editor ::v-deep .ql-container .ql-editor {
		min-height: 300px;
	}

	.el-table::before {
		background: none;
	}

	.dialog-head {
		color: white;
	}

	.dialog-content {
		padding: 0 1.25rem;

		.cell-title {
			margin-bottom: 1.875rem;
			flex-wrap: wrap;

			.til {
				font-size: 1.25rem;
				color: #000;
				font-weight: 530;
				position: relative;
				padding-left: 1.5rem;
				flex-shrink: o;
			}

			.til::after {
				content: "";
				display: block;
				width: 0.25rem;
				height: 1rem;
				position: absolute;
				background-color: #4389E0;
				left: 0.625rem;
				top: 50%;
				margin-top: -8px;
			}

			.tips {
				font-size: 1rem;
				color: red;
				margin-left: 0.625rem;
				width: 100%;
				padding-top: .625rem;
			}

			.tips span {
				text-decoration: underline;
				cursor: pointer;
			}
		}

		.form {
			padding: 0 0.875rem 1.875rem;

			.form-item-textarea {
				width: 100%;
			}

			.select-composite {}

			.itips {
				width: 100%;
				color: red;
				font-size: 14px;
				margin-top: -10px;
				padding-left: 20px;
			}
		}

		.statistics {
			font-size: 1rem;
			padding-left: 1.25rem;

			.statistics-item {
				padding-bottom: 1.25rem;
				color: #999;
				margin-right: 1.25rem;

				span {
					color: #4979ff;
					font-weight: bold;
				}
			}
		}

		.member {
			border-radius: 0.25rem;
			border: 1px solid #E3E7EC;
			padding: 1.25rem;
			margin-bottom: 1.875rem;

			.add-member {
				margin-top: 0.625rem;
				border-radius: 4px;
				border: 1px dashed #E3E7EC;
				text-align: center;
				cursor: pointer;
				color: #4389DF;
				text-align: center;
				padding: 1rem;
				font-size: 1rem;
			}
		}

		.el-upload__tip {
			font-size: 0.875rem;
			margin: 0;
			margin-left: 0.625rem;
			text-align: left;
			color: red;
		}
	}

	.files {
		width: 40rem;
		margin-bottom: 20px;
	}

	.move {
		cursor: pointer;
		padding: 0 10px;
		margin: 0 -10px;
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.review-submit {
			::v-deep .el-form-item {
				width: 100%;
				margin: 0 0 1.25rem;
			}

			::v-deep .el-form .el-form-item {
				padding: 0 10px;
			}

			.dialog-content {
				padding: 0;

				.cell-title {
					margin-bottom: 1.875rem;

					.til {
						font-size: 1rem;
					}
				}

				.form {
					padding: 0 0.625rem;

					.form-item-textarea {
						width: 100%;
					}

					.cell-title {
						margin: 0.625rem -0.625rem 1.25rem !important;
					}
				}

				.member {
					overflow-x: auto;
				}

				.member .table,
				.member .add-member {
					width: 60rem;

				}

				.el-upload__tip {
					width: 100%;
					margin: 1.25rem 0 0.625rem;
				}
			}

			::v-deep {
				.el-dialog__body {}

				.el-dialog {
					width: 100% !important;
					margin-top: 0 !important;
					border-radius: 0 !important;
				}
			}
		}

	}

	.sub-files-title {
		margin-top: -10px;
		font-size: 16px;
		color: #000;

		.tips {
			font-size: 14px;
			color: red;
			padding: 10px 0;
		}

		.ftips {
			font-size: 14px;
			color: red;
			padding-bottom: 10px;
			line-height: 20px;
		}
	}
</style>
<style>
	.el-dialog__title {
		color: white;
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item::before {
		content: '14px';
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
		content: '12px';
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
		content: '18px';
	}

	.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
	.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
		content: '32px';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item::before {
		content: '文本';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
		content: '标题1';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
		content: '标题2';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
		content: '标题3';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
		content: '标题4';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
		content: '标题5';
	}

	.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
	.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
		content: '标题6';
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item::before {
		content: '标准字体';
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
		content: '衬线字体';
	}

	.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
	.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
		content: '等宽字体';
	}

	.el-button--primary.is-plain {
		background-color: #ecf5ff;
	}
</style>